import { 
    TRACK_TYPES, 
    TRACK_TYPE_SORT_INDEX, 
    TRACK_DELIMITER_REGEX 
} from '../constants/winConstants';

/**
 * Convert track type to track type code, like Main -> M, Siding -> 5
 * @param {String} trackType 
 * @returns single-char track type code
 */
export const toCode = (trackType) => {
    for (const [code, name] of Object.entries(TRACK_TYPES)) {
        if (trackType === name) {
            return code;
        }
    }

    return null;
}

/**
 * Convert track type code to track type, like M -> Main, 5 -> Siding
 * @param {String} trackCode 
 * @returns descriptive track type
 */
export const toName = (trackCode) => {
    for (const [code, name] of Object.entries(TRACK_TYPES)) {
        if (trackCode === code) {
            return name;
        }
    }

    return null;
}

/**
 * Standardize each track in the trackList
 * @param {Array} trackList array of tracks returned from trackInfo service
 * @returns new array of tracks with standardized track type
 */
export const standardizeNames = (trackList) => {
    return trackList.map(track => {
        return track.replace('Back Track', 'Back')
            .replace('Main Track', 'Main 0')
            .replace('Passing/Siding', 'Siding')
            .replace('Branch/Main', 'Main');
    });
}

/**
 * Convert track name in trackList to track code, like Main 1 -> M 1; Siding 1234 -> 5 1234;
 * @param {Array} trackList array of tracks, each consists of track name plus track number, like 
 *  ["Main 1", "Siding 1234"]
 * @returns ["M-1", "5-1234"]
 * @note track name in trackList must follow the standard name as defined winConstants/TRACK_TYPES
 */
export const toCode_fromTracks = (trackList) => {
    return trackList.map(track => {
        const [trackName, trackNum] = track.split(TRACK_DELIMITER_REGEX);
        const trackCode = toCode(trackName);

        return trackNum ? trackCode + '-' + trackNum : trackCode;
    });
}

/**
 * Convert track code in trackList to track name, like M-1 -> Main 1; 5-1234 -> Siding 1234;
 * @param {Array} trackList array of tracks, each consists of track type code plus track number, like 
 *  ["M-1", "5-1234"]
 * @returns ["Main 1", "Siding 1234"] used for track list selection at WinEditStep2
 * @note track code in trackList must match the code defined in winConstants/TRACK_TYPES
 */
export const toName_fromTracks = (trackList) => {
    return trackList.map(track => {
        const [trackCode, trackNum] = track.split(TRACK_DELIMITER_REGEX);
        const trackName = toName(trackCode);

        return trackNum ? trackName + ' ' + trackNum : trackName;
    });
}

/**
 * compare two tracks
 * @param {String} trkA first track, a combination of track type and number, like Main 1
 * @param {String} trkB second track
 * @returns 
 * @note used to sort the track list in the Tracks dropdown in the order of 
 *      Main, Siding, Crossover, Back, Yard, Industry
 */
export const sortByTrackType = (trkA, trkB) => {
    const [trkNameA, ] = trkA.split(TRACK_DELIMITER_REGEX);
    const [trkNameB, ] = trkB.split(TRACK_DELIMITER_REGEX);

    trkA = trkA.replace(trkNameA, TRACK_TYPE_SORT_INDEX[trkNameA.toUpperCase()]);
    trkB = trkB.replace(trkNameB, TRACK_TYPE_SORT_INDEX[trkNameB.toUpperCase()]);

    if (trkA > trkB) {
        return 1;
    } else if (trkA < trkB) {
        return -1;
    } else {
        return 0;
    }
}
